// extracted by mini-css-extract-plugin
export default {"header":"header_header__A7NEZ","header__icon":"header_header__icon__fvhNO"};